import { useState, useEffect } from 'react';
const MOBILE_BREAKPOINT = '(max-width: 769px)';
const getInitialIsMobile = () => window.matchMedia(MOBILE_BREAKPOINT).matches;
export const useIsMobile = () => {
  const _useState = useState(getInitialIsMobile),
    isMobile = _useState[0],
    setIsMobile = _useState[1];
  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_BREAKPOINT);
    const handler = e => setIsMobile(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);
  return isMobile;
};
//# sourceMappingURL=useIsMobile.js.map